import React from 'react';
import './App.css';
import { useRoutes } from 'react-router-dom';
import { DarkModeProvider } from './context/DarkMode';
import { UserAuthProvider } from './context/UserAuth';
import Navbar from './navbar/Navbar';
import Routes from './navbar/Routes';

function App() {
  const elements = useRoutes(Routes);
  return (
    <UserAuthProvider>
      <DarkModeProvider>
        <div className='App'>
          <Navbar />
          {elements}
        </div>
      </DarkModeProvider>
    </UserAuthProvider>
  );
}

export default App;
